/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

//Plan type and rebate program
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_QUARTERLY_PAYMENT_DISPLAY =
  'REFRESH_QUARTERLY_PAYMENT_DISPLAY';
export const IS_LOADING = 'IS_LOADING';
export const SET_SELECTED_INPUT = 'SET_SELECTED_INPUT';
export const SET_MANUFACTURERS_LIST = 'SET_MANUFACTURERS_LIST';
export const SET_COMPUTED_FIELDS = 'SET_COMPUTED_FIELDS';
export const SET_BALANCE_THREAD = 'SET_BALANCE_THREAD';
export const SET_AMOUNT_NDC_DETAILS = 'SET_AMOUNT_NDC_DETAILS';
export const SET_NDC_CODES = 'SET_NDC_CODES';
export const REFRESH_QUARTERLY_PAYMENT = 'REFRESH_QUARTERLY_PAYMENT';
export const GET_DRAMS_INVOICE_START_QUARTER_VALUE =
  'GET_DRAMS_INVOICE_START_QUARTER_VALUE';
export const GET_EARLIEST_QTR_DRUG_VALUE = 'GET_EARLIEST_QTR_DRUG_VALUE';
export const GET_QUARTERLY_PAYMENT_DATA = 'GET_QUARTERLY_PAYMENT_DATA';
export const GET_INVOICE_NUM_CHECKED_DATA = 'GET_INVOICE_NUM_CHECKED_DATA';

export const SET_QUARTERLY_PAYMENT_REPORT_DATA_ALL =
  'SET_QUARTERLY_PAYMENT_REPORT_DATA_ALL';
export const SET_PAGINATION_INDEX_QUARTERLY = 'SET_PAGINATION_INDEX_QUARTERLY';
